import platformConfig from './hprofits/index.js';

export default Object.assign(
  {
    statuses: new Map([
      [0, 'active'],
      [1, 'pending'],
      [2, 'closed'],
      [3, 'rejected'],
    ]),
  },
  platformConfig,
);
